import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QueryBuilderService, QueryResult, TableResult } from '../query-builder.service';
import { finalize } from 'rxjs';
// import { CoreModule } from "src/app/core/core.module";

export const FILTER_OPERATORS: { value: FilterOperator; label: string }[] = [
  { value: 'contains',     label: 'Contains' },
  { value: 'not_contains', label: 'Does not contain' },
  { value: 'equals',       label: 'Equals' },
  { value: 'not_equals',   label: 'Not equals' },
  { value: 'starts_with',  label: 'Starts with' },
  { value: 'ends_with',    label: 'Ends with' },
  { value: 'greater_than', label: 'Greater than' },
  { value: 'less_than',    label: 'Less than' },
  { value: 'is_null',      label: 'Is null' },
  { value: 'is_not_null',  label: 'Is not null' },
];

export type FilterOperator =
  | 'contains'
  | 'not_contains'
  | 'equals'
  | 'not_equals'
  | 'starts_with'
  | 'ends_with'
  | 'greater_than'
  | 'less_than'
  | 'is_null'
  | 'is_not_null';

export interface ColumnFilter {
  operator: FilterOperator;
  value: string;
}

@Component({
  selector: 'app-query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.css']
})
export class QueryBuilderComponent {
  constructor(
      private queryBuilderService: QueryBuilderService
    ) {}

  query = '';
  result: QueryResult | null = null;
  error : any = '';
  loading = false;
  // columnFilters: Record<string, string> = {};
  // columnFilters: { [key: string]: string | undefined } = {};

  columnFilters: Record<string, ColumnFilter | undefined> = {};
  showLoader: boolean= false;

   // Pagination state per table
  currentPage: Record<number, number> = {};
  pageSize = 50;
  pageSizeOptions = [50, 100, 250, 500, 750, 1000];

  filterOperators = FILTER_OPERATORS;

  wrapText = false;
  allowUpdate: boolean = false;

  ngOnInit(): void {
    this.setPermissions();
  }

  private setPermissions(): void {
    const permissionList = sessionStorage.getItem('manageQueryBuilderPermissionList');

    if (permissionList) {
      const permissions = permissionList.split(',').map(x => x.trim());
      this.allowUpdate = permissions.includes('118');
    }
  }
  
  run(): void {
    if (!this.query.trim()) return;

    const query = this.query.trim();

    if (!query) {
      this.error = 'Please enter a query.';
      this.loading = false;
      this.showLoader = false;
      return;
    }

    // Check if UPDATE exists anywhere in the query
    const hasUpdate = /\bupdate\b/i.test(query);

    // if (hasUpdate && !this.allowUpdate) {
    //   this.error = 'You do not have permission to execute UPDATE queries.';
    //   this.loading = false;
    //   this.showLoader = false;
    //   return;
    // }

    let finalQuery = query;

    if (hasUpdate) {

      const updateMatch = query.match(
        /UPDATE\s+([a-zA-Z0-9_\[\]\.]+)\s+SET\s+[\s\S]*?(?:\s+WHERE\s+([\s\S]*))?$/i
      );

      if (updateMatch) {

        const tableName = updateMatch[1];
        const whereClause = updateMatch[2]?.trim();

        let selectQuery = `SELECT * FROM ${tableName}`;

        if (whereClause) {
          selectQuery += ` WHERE ${whereClause}`;
        }

        selectQuery += ';';

        finalQuery = `${query};\n${selectQuery}`;
      }
    }

    this.showLoader = true;
    this.error = '';
    this.result = null;
    this.loading = true;

    this.queryBuilderService.execute(finalQuery).subscribe({
      next: (res) => {
        if (res.success) {
          this.result = res.data;
          this.error = null;
        } else {
          this.error = res.error || 'Something went wrong.';
        }

        this.loading = false;
        this.showLoader = false;
      },

      error: (err) => {
        console.error('Query execution failed:', err);

        if (err.status === 0) {
          this.error = 'Unable to connect to server.';
        }
        else if (err.status === 500) {
          this.error = err.error?.Message || 'Internal server error occurred.';
        }
        else if (err.error?.Message) {
          this.error = err.error.Message;
        }
        else {
          this.error = 'Unexpected error occurred while executing query.';
        }

        this.loading = false;
        this.showLoader = false;
      }
    });
  }

  clear(): void {
    this.query = '';
    this.result = null;
    this.error = '';
  }

  //  onFilterChange(col: string, value: string): void {
  //   this.columnFilters[col] = value.toLowerCase().trim();
  //   // Reset all tables to page 1 when filter changes
  //   this.currentPage = {};
  // }

  // getFilteredRows(table: TableResult): Record<string, unknown>[] {
  //   return table.Rows.filter(row =>
  //     table.Columns.every(col => {
  //       const filterVal = this.columnFilters[col];
  //       if (!filterVal) return true;
  //       const cellVal = row[col];
  //       if (cellVal === null || cellVal === undefined) return false;
  //       return cellVal.toString().toLowerCase().includes(filterVal);
  //     })
  //   );
  // }

  // getPaginatedRows(table: TableResult, tableIndex: number): Record<string, unknown>[] {
  //   const filtered = this.getFilteredRows(table);
  //   const page = this.getCurrentPage(tableIndex);
  //   const start = (page - 1) * this.pageSize;
  //   return filtered.slice(start, start + this.pageSize);
  // }

  // getTotalPages(table: TableResult, tableIndex: number): number {
  //   return Math.ceil(this.getFilteredRows(table).length / this.pageSize);
  // }

  // getPageNumbers(table: TableResult, tableIndex: number): number[] {
  //   const total = this.getTotalPages(table, tableIndex);
  //   const current = this.getCurrentPage(tableIndex);

  //   // Show max 5 page numbers with ellipsis logic
  //   const pages: number[] = [];
  //   if (total <= 7) {
  //     return Array.from({ length: total }, (_, i) => i + 1);
  //   }

  //   pages.push(1);
  //   if (current > 3) pages.push(-1); // -1 = ellipsis

  //   const start = Math.max(2, current - 1);
  //   const end = Math.min(total - 1, current + 1);
  //   for (let i = start; i <= end; i++) pages.push(i);

  //   if (current < total - 2) pages.push(-1); // ellipsis
  //   pages.push(total);

  //   return pages;
  // }

  // getCurrentPage(tableIndex: number): number {
  //   return this.currentPage[tableIndex] ?? 1;
  // }

  // goToPage(tableIndex: number, page: number, totalPages: number): void {
  //   if (page < 1 || page > totalPages) return;
  //   this.currentPage[tableIndex] = page;
  // }

  // onPageSizeChange(size: number): void {
  //   this.pageSize = size;
  //   this.currentPage = {}; // reset to page 1
  // }

  // clearFilters(): void {
  //   this.columnFilters = {};
  //   this.currentPage = {};
  // }

    getFilter(col: string): ColumnFilter {
    return this.columnFilters[col] ?? { operator: 'contains', value: '' };
  }

  onOperatorChange(col: string, operator: FilterOperator): void {
    const existing = this.getFilter(col);
    this.columnFilters[col] = { ...existing, operator };
    // is_null / is_not_null don't need a value — clear it
    if (operator === 'is_null' || operator === 'is_not_null') {
      // this.columnFilters[col].value = '';
      const filter = this.columnFilters[col];

      if (filter) {
        filter.value = '';
      }
    }
    this.currentPage = {};
  }

  onFilterValueChange(col: string, value: string): void {
    const existing = this.getFilter(col);
    this.columnFilters[col] = { ...existing, value };
    this.currentPage = {};
  }

  isValueless(col: string): boolean {
    const op = this.getFilter(col).operator;
    return op === 'is_null' || op === 'is_not_null';
  }

  applyFilter(cellVal: unknown, filter: ColumnFilter): boolean {
    const { operator, value } = filter;

    // is_null / is_not_null — no value needed
    if (operator === 'is_null')     return cellVal === null || cellVal === undefined;
    if (operator === 'is_not_null') return cellVal !== null && cellVal !== undefined;

    // no value entered — skip filter
    if (!value.trim()) return true;

    if (cellVal === null || cellVal === undefined) return false;

    const cell  = cellVal.toString().toLowerCase();
    const query = value.toLowerCase().trim();
    const num   = parseFloat(cellVal.toString());
    const queryNum = parseFloat(value);

    switch (operator) {
      case 'contains':     return cell.includes(query);
      case 'not_contains': return !cell.includes(query);
      case 'equals':       return cell === query;
      case 'not_equals':   return cell !== query;
      case 'starts_with':  return cell.startsWith(query);
      case 'ends_with':    return cell.endsWith(query);
      case 'greater_than':
        return !isNaN(num) && !isNaN(queryNum)
          ? num > queryNum
          : cell > query;
      case 'less_than':
        return !isNaN(num) && !isNaN(queryNum)
          ? num < queryNum
          : cell < query;
      default: return true;
    }
  }

  getFilteredRows(table: TableResult): Record<string, unknown>[] {
    return table.Rows.filter(row =>
      table.Columns.every(col => {
        const filter = this.columnFilters[col];
        if (!filter) return true;
        return this.applyFilter(row[col], filter);
      })
    );
  }

  // ── Pagination ─────────────────────────────────────

  getPaginatedRows(table: TableResult, tableIndex: number): Record<string, unknown>[] {
    const filtered = this.getFilteredRows(table);
    const page = this.getCurrentPage(tableIndex);
    const start = (page - 1) * this.pageSize;
    return filtered.slice(start, start + this.pageSize);
  }

  getTotalPages(table: TableResult, tableIndex: number): number {
    return Math.ceil(this.getFilteredRows(table).length / this.pageSize);
  }

  getPageNumbers(table: TableResult, tableIndex: number): number[] {
    const total = this.getTotalPages(table, tableIndex);
    const current = this.getCurrentPage(tableIndex);
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

    const pages: number[] = [1];
    if (current > 3) pages.push(-1);
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    if (current < total - 2) pages.push(-1);
    pages.push(total);
    return pages;
  }

  getCurrentPage(tableIndex: number): number {
    return this.currentPage[tableIndex] ?? 1;
  }

  goToPage(tableIndex: number, page: number, totalPages: number): void {
    if (page < 1 || page > totalPages) return;
    this.currentPage[tableIndex] = page;
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = {};
  }

  clearFilters(): void {
    this.columnFilters = {};
    this.currentPage = {};
  }

  hasActiveFilters(): boolean {
    return Object.values(this.columnFilters).some(
      f => f?.operator === 'is_null' || f?.operator === 'is_not_null' || !!f?.value.trim()
    );
  }

  activeFilterColumn: string | null = null;
  toggleFilterMenu(col: string): void {
  if (this.activeFilterColumn === col) {
    this.activeFilterColumn = null;
  } else {
    this.activeFilterColumn = col;
  }
}
exportToExcel(query: string): void {

  if (!query) {
    this.error = 'Please enter a query.';
    this.loading = false;
    this.showLoader = false;
    return;
  }

  // Check if UPDATE exists anywhere in the query
  const hasUpdate = /\bupdate\b/i.test(query);

  if (hasUpdate) {
    this.error = 'Export is not available for UPDATE queries. Please execute a SELECT query to export data.';
    this.loading = false;
    this.showLoader = false;
    return;
  }

  this.showLoader = true;
  this.error = null;

  this.queryBuilderService.exportToExcel(query).subscribe({
    next: (blob: Blob) => {

      // Backend returned error text instead of excel
      if (blob.type === 'text/plain') {

        const reader = new FileReader();

        reader.onload = () => {
          this.error = reader.result as string;
          this.showLoader = false;
        };

        reader.readAsText(blob);
        return;
      }

      // Valid excel file
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `QueryExport_${this.getTimestamp()}.xlsx`;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      this.showLoader = false;
    },

    error: (err) => {
      if (err.status === 0) {
        this.error = 'Unable to connect to server.';
      }
      else {
        this.error = 'Unexpected error occurred while exporting Excel.';
      }

      this.showLoader = false;
    }
  });
}

  getTimestamp(): string {
    const now = new Date();

    return `${now.getFullYear()}${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}${now.getDate()
      .toString()
      .padStart(2, '0')}_${now.getHours()
      .toString()
      .padStart(2, '0')}${now.getMinutes()
      .toString()
      .padStart(2, '0')}${now.getSeconds()
      .toString()
      .padStart(2, '0')}`;
  }

  // Add these methods to your QueryBuilderComponent class

  // Helper method to safely convert unknown to string
  private convertToString(value: unknown): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    }
    return String(value);
  }

  // Method to check if a value is XML
  isXML(value: unknown): boolean {
    if (!value || typeof value !== 'string') return false;

    const trimmed = value.trim();
    // Check if it starts with < and contains XML-like structure
    return trimmed.startsWith('<?xml') ||
      (trimmed.startsWith('<') && trimmed.includes('</') && trimmed.includes('>'));
  }

  // Optional: Validate if content is valid XML
  isValidXML(xmlString: string): boolean {
    if (!xmlString) return false;

    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
      const parserError = xmlDoc.querySelector('parsererror');
      return !parserError;
    } catch (e) {
      return false;
    }
  }

  // Optional: Format XML for better readability
  formatXMLBeforeOpen(xmlString: string): string {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

      // Check for parsing errors
      const parserError = xmlDoc.querySelector('parsererror');
      if (parserError) {
        return xmlString; // Return original if invalid
      }

      // Format with proper indentation
      const serializer = new XMLSerializer();
      let formatted = serializer.serializeToString(xmlDoc);

      // Add line breaks for better readability
      formatted = formatted.replace(/(>)(<)(\/*)/g, '$1\n$2$3');

      return formatted;
    } catch (e) {
      return xmlString;
    }
  }

  // Main method to open XML in default browser
  openXMLModal(xmlContent: unknown, columnName: string): void {
    // Convert to string
    let xmlString = this.convertToString(xmlContent);
    if (!xmlString) {
      console.warn('Empty XML content');
      return;
    }

    // Optional: Format the XML for better readability (comment this line if you want raw XML)
    xmlString = this.formatXMLBeforeOpen(xmlString);

    // Add XML declaration if not present (optional, for better browser display)
    if (!xmlString.trim().startsWith('<?xml')) {
      xmlString = '<?xml version="1.0" encoding="UTF-8"?>\n' + xmlString;
    }

    try {
      // Create blob with XML content
      const xmlBlob = new Blob([xmlString], { type: 'application/xml' });
      const url = URL.createObjectURL(xmlBlob);

      // Open in new tab with default browser
      window.open(url, '_blank');

      // Clean up the URL object after a delay
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    } catch (error) {
      console.error('Error opening XML:', error);
      // Fallback: Try to open as text if XML fails
      const textBlob = new Blob([xmlString], { type: 'text/plain' });
      const url = URL.createObjectURL(textBlob);
      window.open(url, '_blank');
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    }
  }

  // Alternative method to download as XML file
  downloadXML(xmlContent: unknown, columnName: string): void {
    let xmlString = this.convertToString(xmlContent);
    if (!xmlString) return;

    // Format if needed
    xmlString = this.formatXMLBeforeOpen(xmlString);

    // Add XML declaration if not present
    if (!xmlString.trim().startsWith('<?xml')) {
      xmlString = '<?xml version="1.0" encoding="UTF-8"?>\n' + xmlString;
    }

    // Create blob and download
    const xmlBlob = new Blob([xmlString], { type: 'application/xml' });
    const url = URL.createObjectURL(xmlBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${columnName.replace(/[^a-z0-9]/gi, '_')}_${Date.now()}.xml`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  // Helper method to get cell value as string (for non-XML display)
  getCellValue(value: unknown): string {
    if (value === null || value === undefined) return 'NULL';
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (e) {
        return String(value);
      }
    }
    return String(value);
  }

}
